import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Paintbrush = (props: SvgProps) => (
  <Svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
    <g filter="url(#paintbrush_filter)">
      <path
        d="M17.9148 4.58497C17.7291 4.39921 17.5086 4.25185 17.2659 4.15131C17.0232 4.05077 16.7631 3.999 16.5004 3.999C16.2377 3.999 15.9776 4.05077 15.735 4.15131C15.4923 4.25185 15.2718 4.39921 15.0861 4.58497C15.0773 4.59372 15.0686 4.6031 15.0598 4.6131L11.7217 8.51372L11.0623 7.85247C10.923 7.7131 10.7576 7.60254 10.5756 7.52711C10.3935 7.45168 10.1984 7.41285 10.0014 7.41285C9.80432 7.41285 9.6092 7.45168 9.42716 7.52711C9.24512 7.60254 9.07973 7.7131 8.94043 7.85247L4.14731 12.6462C4.05361 12.74 4.00098 12.8671 4.00098 12.9997C4.00098 13.1322 4.05361 13.2593 4.14731 13.3531L9.14731 18.3531C9.24107 18.4468 9.36819 18.4994 9.50074 18.4994C9.6333 18.4994 9.76042 18.4468 9.85418 18.3531L14.6473 13.5625C14.7867 13.4232 14.8972 13.2578 14.9727 13.0757C15.0481 12.8937 15.0869 12.6986 15.0869 12.5015C15.0869 12.3045 15.0481 12.1094 14.9727 11.9273C14.8972 11.7453 14.7867 11.5799 14.6473 11.4406L13.9861 10.78L17.8867 7.43747C17.8961 7.42872 17.9061 7.41997 17.9148 7.4106C18.289 7.03564 18.4992 6.52753 18.4992 5.99778C18.4992 5.46804 18.289 4.95993 17.9148 4.58497ZM9.49981 17.2931L8.45731 16.25L9.85356 14.8531C9.94337 14.7586 9.9927 14.6327 9.99103 14.5023C9.98936 14.3719 9.93682 14.2474 9.84462 14.1552C9.75242 14.063 9.62785 14.0104 9.49747 14.0088C9.36709 14.0071 9.24121 14.0564 9.14668 14.1462L7.74981 15.5425L6.95731 14.75L8.35356 13.3531C8.44337 13.2586 8.4927 13.1327 8.49103 13.0023C8.48936 12.8719 8.43682 12.7474 8.34462 12.6552C8.25242 12.563 8.12785 12.5104 7.99747 12.5088C7.86709 12.5071 7.74121 12.5564 7.64668 12.6462L6.24981 14.0425L5.20668 13L8.35356 9.85372L12.6467 14.1468L9.49981 17.2931Z"
        fill="url(#paintbrush_gradient)"
      />
    </g>
    <defs>
      <filter
        id="paintbrush_filter"
        x="2.5784"
        y="2.4368"
        width="17.664"
        height="17.152"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />

        {/* Simplified inner shadow effects */}
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.9216" dy="0.5888" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0 0.886275 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="shadow1" />

        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha2"
        />
        <feOffset dx="0.7424" dy="-0.5632" />
        <feGaussianBlur stdDeviation="0.8" />
        <feComposite in2="hardAlpha2" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shadow1" result="shadow2" />

        {/* Simplified noise effect */}
        <feTurbulence
          type="fractalNoise"
          baseFrequency="35"
          numOctaves="2"
          result="noise"
          seed="2877"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feFlood floodColor="rgba(255, 235, 128, 0.2)" result="noiseColor" />
        <feComposite
          operator="in"
          in2="alphaNoise"
          in="noiseColor"
          result="coloredNoise"
        />
        <feComposite
          operator="multiply"
          in2="shadow2"
          in="coloredNoise"
          result="finalNoise"
        />

        <feMerge>
          <feMergeNode in="shadow2" />
          <feMergeNode in="finalNoise" />
        </feMerge>
      </filter>

      <linearGradient
        id="paintbrush_gradient"
        x1="23.0838"
        y1="3.12798"
        x2="9.52645"
        y2="22.6386"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="1" stopColor="#FFEB80" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Paintbrush;
